import React, {useEffect, useRef} from "react";
import {PlusOutlined, ArrowLeftOutlined} from "@ant-design/icons";
import { Button, } from "antd";
import MyProLayout from "../../components/MyProLayout";
import {ActionType, ProTable} from "@ant-design/pro-components";
import FetchUtil from "../../utils/FetchUtil";
import moment from "moment";
import BlogCrawlEditor from "./BlogCrawlEditor";
import {useParams} from "react-router-dom";
import {useNavigate} from "react-router";


const Sum = () => {

    let navigate = useNavigate();
    const actionRef = useRef<ActionType>();
    const formRef = useRef();

    const {sumDate} = useParams();

    useEffect(() => {
        actionRef.current?.reload();
    }, [sumDate]);

    const openEdit = (r?: any) => {
        if (!r) {
            r = {sendTime: new Date()};
        }
        (formRef.current as any).openEditor(r);
    }
    // '', '', '', '', '
    const columns: any[] = [
        {
            title: '日期',
            dataIndex: 'sumDate',
            align: 'center' as 'center',
            width: 100,
            valueType: "date",
        },
        {
            title: sumDate ?  "游戏" : "游戏总数",
            dataIndex: "game",
            width: 100,
            render: (v: any, r: any) => {return sumDate
                ? <>{r.gameName}</>
                : <a href={`/#/mall/aiblog/sum/${moment(r.sumDate).format("yyyy-MM-DD")}`}>{r.game}</a>
            }
        },
        {
            title: '网站总数',
            dataIndex: 'website',
            align: 'center' as 'center',
            width: 80,
        },
        {
            title: '当日新增内容网站',
            dataIndex: 'dailyWeb',
            align: 'center' as 'center',
            width: 80,
        },
        {
            title: '当日新增文章数',
            dataIndex: 'dailyBlog',
            align: 'center' as 'center',
            width: 80,
        },
        {
            title: '当日AI生产文章数',
            dataIndex: 'dailyAi',
            align: 'center' as 'center',
            width: 80,
        },
        {
            title: '总计抓取',
            dataIndex: 'totalBlog',
            align: 'center' as 'center',
            width: 80,
        },
        {
            title: '最新抓取',
            dataIndex: 'lastBlog',
            align: 'center' as 'center',
            width: 120,
            valueType: "dateTime",
        },
        {
            title: '当日UV总数',
            dataIndex: 'dailyUv',
            align: 'center' as 'center',
            width: 80,
        },
        {
            title: '前一日文章UV',
            dataIndex: 'prevUv',
            align: 'center' as 'center',
            width: 80,
        },
        {
            title: '当日抓取错误',
            dataIndex: 'dailyError',
            align: 'center' as 'center',
            width: 80,
        },
    ];

    return (
        <MyProLayout>
            <ProTable
                rowKey={"id"}
                // headerTitle={stat}
                toolbar={{
                    actions: [
                        <Button type='primary' onClick={() => openEdit()} key='0'><PlusOutlined/> 新建</Button>
                    ],
                }}
                search={false}
                // search={{span: 5}}
                actionRef={actionRef}
                columns={columns}
                cardBordered={true}
                request={async (
                    params,
                    // sort,
                    // filter,
                ) => {
                    const query: any = {
                        query: {...params,
                            type: sumDate ? 'game' : 'all',
                            sumDate: sumDate ? sumDate + 'T00:00:00.000+00:00' : ''},
                        page: {
                            pageNo: params.current,
                            pageSize: params.pageSize,
                            // orderBy: " id desc"
                        }
                    }
                    const res = await FetchUtil.awaitFetch('/mallApi/blog/blogSum', query);
                    console.log(res)
                    return {
                        success: true,
                        data: res.data.list,
                        total: res.data.total,
                    };
                }}
                headerTitle={<>
                    <div hidden={!sumDate}>
                        <Button type='link' onClick={() => navigate(-1)}><ArrowLeftOutlined/> 返回</Button>
                    </div>
                </>}
            />
        <BlogCrawlEditor ref={formRef} columns={columns} callback={() => actionRef.current?.reload()} />

        </MyProLayout>
    );
}

export default Sum;
